module.exports = __webpack_public_path__ + "static/media/BBConditioner.6b5e137c.png";